class NewsletterSignup extends HTMLElement {
  constructor() {
    super();
    this.newsletterContainer = this;
    this.newsletterForm = this.querySelector('.newsletter-form')
    this.emailField = this.querySelector('.newsletter-form__input')
    this.submitButton = this.querySelector('[type="submit"]')
    this.isSubmitted = false

    this.newsletterForm.addEventListener('submit', (event) => {
      this.handleSubmitForm(event)
    });
  }

  handleSubmitForm(event) {
    if (this.isSubmitted) {
      event.preventDefault()
    }

    this.bloomreachTrackEvent(this)
    this.isSubmitted = true
    this.submitButton.classList.add('is-loading')
    this.submitButton.setAttribute("disabled", "true");
  }

  bloomreachTrackEvent() {
    exponea.identify(
      { email_id: this.emailField.value.toLowerCase().trim() },
      { email: this.emailField.value.toLowerCase().trim() }
    );
    
    exponea.track('consent',
      {
        "action": "accept",
        "category": "Marketing",
        "valid_until": "unlimited",
        "message": "This consent was tracked from footer's newsletter signup form" // additional attribute
      }
    );
  }
}

customElements.define('newsletter-signup', NewsletterSignup);
